import axios from "axios"
function _getAdjustRedirectUrl(url) {
    const uRL = new URL(url)
    const p0 = uRL.searchParams.get('p0')
    const p1 = uRL.searchParams.get('p1')
    const p2 = uRL.searchParams.get('p2')
    const p3 = uRL.searchParams.get('p3')
    const p4 = uRL.searchParams.get('p4')
    const p5 = uRL.searchParams.get('p5')
    const p6 = uRL.searchParams.get('p6')
    const fbclid = uRL.searchParams.get('fbclid')
    const fbpid = uRL.searchParams.get('fbpid')
    // let _url = `https://app.adjust.com/impression/${p0}?campaign=${p1}%20%28${p2}%29&adgroup=${p3}%20%28${p4}%29&creative=${p5}%20%28${p6}%29`
    let _url = `https://view.adjust.com/impression/${p0}?campaign=${p1}%20%28${p2}%29&adgroup=${p3}%20%28${p4}%29&creative=${p5}%20%28${p6}%29
`
    // if (fbclid) {
    //   _url += `&fbclid=${fbclid}`
    // }
    // if (fbpid) {
    //   _url += `&fbpid=${fbpid}`
    // }
    // console.log('_url', _url)
    return _url
  }
  function requestViewStatistics(url) {
    if(!url.includes('p0=')) {
      return;
    }
    const _url = _getAdjustRedirectUrl(url)
    return axios.get(_url, {
      timeout: 5000,
    }).then(response => {
      console.log('View statistics response:', response.data)
      return response.data
    }).catch(error => {
      console.error('Error fetching view statistics:', error)
      throw error
    })
  }

  export  {requestViewStatistics}